import { Button, Typography } from '@material-ui/core'
import BlockIcon from '@material-ui/icons/Block'

import { getTranslate } from '../../localization'
import { LocalizedLink } from '../../routes/localizedRoutes'
import useStyles from './styles/index.styles'

/**
 * Shown when a screen refuses access.
 *
 * Fifteen screens already redirected to `/403` and no route or component existed for it. The
 * router's `Switch` has no catch-all, so every one of those redirects rendered an empty
 * element: the drawer stayed on screen and the content area went white. "The page is blank"
 * was the reported symptom, and the cause was a refusal nobody could see.
 *
 * The route carries `requiredFeatures: []` so it renders for anyone. Gating the page that
 * explains a denial behind the permission system is how a denial becomes a blank page again.
 */
const Forbidden = () => {
  const classes = useStyles()

  return (
    <div className={classes.root} data-testid="forbidden">
      <BlockIcon className={classes.icon} />
      <Typography variant="h5" className={classes.title}>
        {getTranslate('You do not have access to this page')}
      </Typography>
      <Typography variant="body1" className={classes.body}>
        {getTranslate(
          'If you believe this is a mistake, ask an administrator to review your access.'
        )}
      </Typography>
      <Button
        variant="contained"
        color="primary"
        component={LocalizedLink}
        to="/home">
        {getTranslate('Home')}
      </Button>
    </div>
  )
}

export default Forbidden
